import { graphql, useStaticQuery } from 'gatsby'

// relative link for the Link component, e.g. helpCenterPath('clients', 'payment-refund') -> 'help/clients/payment-refund/'
export const helpCenterPath = (...segments) => ['help', ...segments].map(segment => `${segment}/`).join('')

// categories -> folders -> articles, as described by the help page frontmatter of the given country
export const useHelpCenter = country => {
  const { tree, articles } = useStaticQuery(graphql`
    query {
      tree: allMdx(filter: { frontmatter: { slug: { eq: "help" }, type: { eq: "page" } } }) {
        nodes {
          frontmatter {
            country
            help_center {
              categories {
                slug
                title
                folders {
                  slug
                  title
                }
              }
            }
          }
        }
      }
      articles: allMdx(
        filter: { frontmatter: { type: { eq: "help-article" } } }
        sort: { order: ASC, fields: [frontmatter___order] }
      ) {
        nodes {
          frontmatter {
            title
            country
            category
            folder
            article_slug
            last_updated_at(formatString: "DD MMM YYYY")
          }
        }
      }
    }
  `)

  const { categories } = tree.nodes.find(node => node.frontmatter.country === country).frontmatter.help_center
  const countryArticles = articles.nodes
    .map(node => node.frontmatter)
    .filter(article => article.country === country)

  return categories.map(category => ({
    ...category,
    folders: category.folders
      .map(folder => ({
        ...folder,
        articles: countryArticles.filter(article => article.category === category.slug && article.folder === folder.slug),
      }))
      .filter(folder => folder.articles.length > 0),
  }))
}
